import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const fastFieldReprocessQueueColumns: GridColumnConfig[] = [
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    // width: '220',
    searchable: true,
  },
  {
    title: 'Address',
    field: 'address',
    filter: 'text',
    // width: '220',
    searchable: true,
  },
  {
    title: 'Lot Number',
    field: 'unitName',
    filter: 'text',
    // width: '220',
    searchable: true,
  },
  {
    title: 'SI Inspection Type',
    field: 'siInspectionTypeFF',
    filter: 'text',
    searchable: true,
    // width: '150',
  },
  {
    title: 'Reference WO#',
    field: 'referenceWOFF',
    filter: 'text',
    // width: '180',
    searchable: true,
  },
  {
    title: 'Reinspection WO#',
    field: 'reinspectionWO',
    filter: 'text',
    // width: '180',
    searchable: true,
  },
  {
    title: 'Inspector Name',
    field: 'inspectorName',
    filter: 'text',
    // width: '180',
    searchable: true,
  },
  {
    title: 'Inspection Date',
    field: 'scheduledDate',
    filter: 'text',
    // width: '180',
    searchable: true,
  },
  {
    title: 'Market Area',
    field: 'marketAreas',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Project Department',
    field: 'projectDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Lot Department',
    field: 'unitDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
];
